"use strict";

export const Constants = {
	screenSizes: {
		screenXsMax: 767,
		screenSmMx: 991
	}
};

